import React from 'react'
import './footer.css';

const Footer = () => {
  return (
    // Footer component for footer items - copyright text
    <footer className='footer'>
        Copyright &#169; 2023 Narotam Mishra. All rights reserved.
    </footer>
  )
}

export default Footer;